import { Constants } from "./constants";

/**
 * Human-readable display labels for course/class categories.
 * Keyed by Constants.course_category value.
 */
export const CourseCategoryLabels = new Map<string, string>([
  [Constants.course_category.nosework,          "Nosework / Scentwork"],
  [Constants.course_category.rally_obedience,   "Rally Obedience"],
  [Constants.course_category.conformation,      "Conformation"],
  [Constants.course_category.obedience,         "Obedience"],
  [Constants.course_category.dock_diving,       "Dock Diving"],
  [Constants.course_category.barn_hunt,         "Barn Hunt"],
  [Constants.course_category.agility,           "Agility"],
  [Constants.course_category.behaviour,         "Behaviour & Training"],
  [Constants.course_category.tracking,          "Tracking"],
  [Constants.course_category.herding,           "Herding"],
  [Constants.course_category.lure_coursing,     "Lure Coursing / Fast CAT"],
  [Constants.course_category.tricks,            "Trick Dog"],
  [Constants.course_category.sport_foundations, "Sport Foundations"],
  [Constants.course_category.handling,          "Handling & Presentation"],
  [Constants.course_category.health_wellness,   "Health & Wellness"],
  [Constants.course_category.other,             "Other"],
]);

/** Returns the display label for a category value, or the raw value as fallback. */
export function getCourseCategoryLabel(category: string): string {
  return CourseCategoryLabels.get(category) ?? category;
}

/** Reverse-lookup: returns the stored constant value for a given display label. */
export function getCourseCategoryValue(label: string): string {
  for (const [value, lbl] of CourseCategoryLabels) {
    if (lbl === label) return value;
  }
  return label;
}

/** Sorted array of all category display labels, for use in dropdowns and filters. */
export const COURSE_CATEGORY_OPTIONS: string[] = Array.from(CourseCategoryLabels.values());
